<template>
  <div id="app">
    <b-navbar toggleable="md" type="dark" fixed="top" v-if="user !== false && user !== null">
      <b-nav-toggle target="nav_collapse"></b-nav-toggle>

      <b-nav is-nav-bar>
        <b-nav-item v-on:click="back">
          <icon name="angle-left"></icon> Back
        </b-nav-item>
      </b-nav>

      <b-nav is-nav-bar class="ml-auto">
        <b-nav-item v-on:click="home">
          <icon name="home"></icon>
        </b-nav-item>
        <b-nav-item v-on:click="logout">
          <icon name="sign-out"></icon>
        </b-nav-item>
      </b-nav>
    </b-navbar>

    <router-view v-if="user !== null" :fb.sync="fb"></router-view>
  </div>
</template>

<script>
import { logOut } from './auth'

export default {
  name: 'app',
  computed: {
    user: () => {

    }
  },
  methods: {
    home () {
      this.$router.push('/')
    },
    logout () {
      logOut()
      this.$router.push('/login')
    },
    back () {
      this.$router.go(-1)
    }
  },
  props: ['fb']
}
</script>

<style lang="scss">
  @import './assets/scss/app.scss';
</style>

<style>
  @import url('https://fonts.googleapis.com/css?family=Quicksand:300,400,500,700&ver=4.8.1');

  #app {
    font-family: 'Quicksand', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue